// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"681427c7","567":"ae5c601f","781":"c788a204"}[chunkId] + ".chunk.css";
};